<template>
      <div class="wapper">
        <div class="top">
          <img src="@/assets/logo-index.png" class="logoIndex">
          <div class="nav">
              <div class="navList" v-for="(item,index) in MenuArray" :key="index" :class="item.id === activeIndex ? 'tab-active' : ''" @click="handoff(item)">{{item.name}}</div>
          </div>
        </div>
        <div  class="content">
              <template v-if="activeIndex==='1'">
                <div class="mainDetailList">专业家用产后修复品牌</div>
              </template>
              <template v-if="activeIndex==='2'">
                <About></About>
              </template>
              <template v-if="activeIndex==='3'">
                 <div class="starProducts">
                   <div class="productsWapper">
                     <div class="products">
                       雅致盆底肌修复仪
                       <div class="hen"></div>
                     </div>
                     <div class="introduce">
                       <div class="introduceList">你的移动盆底肌修复专家</div>
                       <div class="introduceList">e l e c h c y生电科技联合 </div>
                       <div class="introduceList">居家享受门诊级盆底修复治疗</div>
                     </div>
                   </div>
                 </div>
              </template>
              <template v-if="activeIndex==='4'">
                <ServiceCenter></ServiceCenter>
              </template>
        </div>
        <div  class="footer" @click="jump">备案号“湘ICP备2023005389号”</div>
      </div>
</template>

<script>
import About from "./About.vue"
import ServiceCenter from "./ServiceCenter.vue"
export default {
  components: {
    About,
    ServiceCenter
  },
  name: 'Index',
  data () {
    return {
      activeIndex: '1',
      MenuArray:[
        {
          name:'首页',
          id:'1',
        },
        {
          name:'关于我们',
          id:'2',
        },
        {
          name:'明星产品',
          id:'3',
        },
        {
          name:'服务中心',
          id:'4',
        },
      ]
    }
  },
  methods: {
    handoff(item){
      this.activeIndex = item.id
    },
    jump() {
      window.open('https://beian.miit.gov.cn', '_blank')
    }
  },
}
</script>

<style scoped>
.wapper{
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.top {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
}
.logoIndex {
  width: 4.5rem;
  height: auto;
  margin-top: 0.4rem;
}
.nav{
  display: flex;
  margin-top: 0.3rem;
}
.navList {
  color: #090404;
  cursor: pointer;
  font-size: 0.38rem;
  padding: 0.3rem 0.3rem;
  margin: 0 0.5rem;
}
.tab-active{
  color: #cc9f59;
  border-bottom: 2px solid #cc9f59;
}
.content{
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  overflow: hidden;
}
.mainDetailList{
  font-size: 0.5rem;
  text-align: center;
  color: #090404;
  width: 100%;
  overflow: auto;
  height: 100%;
  padding: 2% 10%;
  box-sizing: border-box;

}
.starProducts{
  width: 100%;
  overflow: auto;
  height: 100%;
  padding: 2% 10%;
  box-sizing: border-box;
}
.productsWapper{
  width: 6rem;
  margin: auto;
}
.products{
  width: 6rem;
  border-bottom: 1.5px #090404 solid;
  font-size: 0.5rem;
  position: relative;
  padding-bottom: 0.3rem;
  margin-bottom: 0.3rem;
}
.hen{
  position: absolute;
  height: 6px;
  width: 1rem;
  background: #cf904e;
  bottom: -3px;
}
.introduce{
  width: 6rem;
}
.introduceList{
  font-size: 0.34rem;
  color: #555;
  margin-bottom: 0.1rem;
}
.footer{
  flex: 0 0 auto;
  width: 100%;
  padding: 0.2rem 0rem;
  text-align: center;
  font-size: 0.3rem;
  background-color: #a99476;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue